import { LDD_GETLISTA_START } from "../../const/actionTypes";

export const GetLdD = (payload) => ({
  type: LDD_GETLISTA_START,
  payload,
});
